// MfaAuthSelectPanel.js
import React, { useState, useEffect, useRef } from 'react';
import styles from '../../MfaPage.module.css';  
import axios from "../../../../utils/api/axios";
import { Fido2 } from '../../../../core/fido2.ts';
import { InnocodeButton } from '@intsoft/innocode-core';

function MfaPasskeyVerifyPanel({ onSuccess, onBack, userId }) {

    const handleAuth = async () => {
        const result = await Fido2.authenticateButtonClicked(userId);
        const resultJson = JSON.parse(result);
        if(resultJson.status === 'ok'){
            onSuccess();
        }
    }


    return (
        <div className={styles.section_wrapper}>
            <div className={styles.section_header_wrapper}>
                <div className={styles.header_text}>패스키 인증</div>
                <div className={styles.header_description}>
                    기기에서 지문, 얼굴 또는 화면 잠금을 요청합니다.
                </div>
            </div>
            <div className={styles.verify_wrapper}>
                <div className={styles.submit_btn_container}>
                    <InnocodeButton
                        onClick={handleAuth}
                        size='lg'
                        className={styles.submit_btn}
                    >
                        계속
                    </InnocodeButton>
                    <InnocodeButton
                        onClick={onBack}
                        designType='assistive'
                        theme='line'
                        size='lg'
                        className={styles.submit_btn}
                    >
                        다른 수단으로 인증하기
                    </InnocodeButton> 
                </div>
            </div>
        </div>
    );
}

export default MfaPasskeyVerifyPanel;